import type ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import ModelsContext from '@/lib/contexts/ModelsContext';
import { type Model } from '@/lib/types';
import { useContext } from 'react';

const useDefaultModel = (modelType: ModelType): Model | null => {
  const models = useContext(ModelsContext);

  for (const model of Object.values(models[modelType])) {
    if (model.isDefault) {
      return model;
    }
  }

  return null;
};

export default useDefaultModel;
